
import { createApiSlice } from "@common/common-slice/commonSlice";

// routes

// ---------------------------------------------------------------------

const apiConfig = [
];

const customReducers = {
  initialState: {
    publishAssessmentData: [],
  },

  reducers: {
  },

  extraReducers: {
  },
};

const { slice, thunks, actions } = createApiSlice(
  "publishAssessment",
  apiConfig,
  customReducers,
);

const publishAssessmentSlice = slice;

export default publishAssessmentSlice.reducer;

export const {
  rowSelect,
} = actions;